<template>
  <div>
    <course-listing-table :courseType="Regular"></course-listing-table>
    <course-listing-table :courseType="Live"></course-listing-table>
  </div>
</template>

<script>
import CourseListingTable from "../components/courseListingTable";

export default {
    components: {CourseListingTable},
    data(){
        return{
            Regular:"regular",
            Live:"live"
        }
    },
    name: "CoursesListing"
};
</script>

<style scoped></style>
